import React from 'react';
import { Layout } from '../../components/Layout';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Calendar, Clock, ArrowRight, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
export function BlogIndexPage() {
  const articles = [{
    title: 'Скільки коштують імпланти в Лондоні? Повний гід по цінах 2025',
    excerpt: 'Розбираємо вартість імплантації зубів у Лондоні: від чого залежить ціна, що входить у вартість та як уникнути прихованих платежів.',
    category: 'Імплантація',
    readTime: '8 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/skilky-koshtuyut-implanty-london'
  }, {
    title: 'NHS vs приватна стоматологія у Великобританії — що обрати?',
    excerpt: 'Порівнюємо державну (NHS) та приватну стоматологію: ціни, черги, якість матеріалів та доступність для українців.',
    category: 'Гід пацієнта',
    readTime: '10 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/nhs-vs-private-dentistry-uk'
  }, {
    title: 'Чи можна лікувати зуби в UK без страховки? Гід для українців',
    excerpt: 'Все про доступ до стоматології без страховки: як зареєструватися, скільки коштує візит та які є альтернативи.',
    category: 'Поради',
    readTime: '7 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/likuvannya-zubiv-uk-bez-strakhovky'
  }, {
    title: 'Що робити при зубному болю в Лондоні? Покрокова інструкція',
    excerpt: 'Куди звертатися з гострим болем: NHS 111, невідкладна допомога, приватні клініки. Поради першої допомоги.',
    category: 'Невідкладна допомога',
    readTime: '6 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/zubnyi-bil-london-shcho-robyty'
  }, {
    title: 'Вініри в Лондоні — все, що потрібно знати перед встановленням',
    excerpt: 'Гід по вінірах: типи, ціни, процес встановлення та як обрати між керамікою та композитом.',
    category: 'Естетика',
    readTime: '9 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/viniry-london-shcho-potribno-znaty'
  }, {
    title: 'Як обрати стоматолога в Angel, Islington? Поради для українців',
    excerpt: 'На що звертати увагу при виборі клініки: GDC реєстрація, відгуки, обладнання та мова спілкування.',
    category: 'Поради',
    readTime: '7 хв',
    date: 'Лютий 2026',
    link: '/ua/blog/yak-obraty-stomatologa-angel'
  }];
  return <Layout data-id="element-435">
      <section className="bg-teal-50 py-16 lg:py-24" data-id="element-436">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-437">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-800 text-sm font-medium mb-6" data-id="element-438">
            <BookOpen className="w-4 h-4" data-id="element-439" />
            Блог Dentico Clinic
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6" data-id="element-440">
            Корисна інформація для українців у Лондоні
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-441">
            Відповіді на важливі питання про стоматологію у Великобританії,
            поради лікарів та гіди по лікуванню.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white" data-id="element-442">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-443">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-444">
            {articles.map((article, idx) => <Link key={idx} to={article.link} className="group h-full" data-id="element-445">
                <Card className="h-full flex flex-col hover:shadow-lg transition-all duration-300 border-gray-100 hover:border-teal-200" data-id="element-446">
                  <div className="p-6 flex flex-col h-full" data-id="element-447">
                    <div className="flex items-center justify-between mb-4" data-id="element-448">
                      <span className="text-xs font-bold text-teal-600 bg-teal-50 px-2 py-1 rounded-md uppercase tracking-wide" data-id="element-449">
                        {article.category}
                      </span>
                      <div className="flex items-center text-gray-400 text-xs" data-id="element-450">
                        <Clock className="w-3 h-3 mr-1" data-id="element-451" />
                        {article.readTime}
                      </div>
                    </div>

                    <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2" data-id="element-452">
                      {article.title}
                    </h2>

                    <p className="text-gray-600 text-sm mb-6 flex-grow line-clamp-3" data-id="element-453">
                      {article.excerpt}
                    </p>

                    <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-50" data-id="element-454">
                      <span className="text-xs text-gray-400 font-medium flex items-center" data-id="element-455">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-456" />
                        {article.date}
                      </span>
                      <span className="text-sm font-medium text-teal-600 flex items-center group-hover:translate-x-1 transition-transform" data-id="element-457">
                        Читати <ArrowRight className="w-4 h-4 ml-1" data-id="element-458" />
                      </span>
                    </div>
                  </div>
                </Card>
              </Link>)}
          </div>
        </div>
      </section>

      <section className="py-16 bg-teal-900" data-id="element-459">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-460">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-461">
            Не знайшли відповідь на своє запитання?
          </h2>
          <p className="text-teal-100 mb-8 max-w-2xl mx-auto" data-id="element-462">
            Зв'яжіться з нами напряму — ми проконсультуємо українською мовою.
          </p>
          <Link to="/ua/contact" data-id="element-463">
            <Button size="lg" className="bg-white text-teal-900 hover:bg-teal-50" data-id="element-464">
              Зв'язатися з нами
            </Button>
          </Link>
        </div>
      </section>
    </Layout>;
}